interface ActionStringBuilder {
  title: (type: string) => string;
  success: (type: string) => string;
}

export interface ActionsHandler {
  create: ActionStringBuilder;
  update: ActionStringBuilder;
  delete: ActionStringBuilder;
}

interface ActionStrings {
  title: string;
  success: string;
}

export interface ActionStringCollection {
  create: ActionStrings;
  update: ActionStrings;
  delete: ActionStrings;
}

export const GetActionBuilder = (
  type: string,
  handler: ActionsHandler
): ActionStringCollection => ({
  create: {
    success: handler.create.success(type),
    title: handler.create.title(type),
  },
  update: {
    success: handler.update.success(type),
    title: handler.update.title(type),
  },
  delete: {
    success: handler.delete.success(type),
    title: handler.delete.title(type),
  },
});
